/**
 * UnitPanel is normally rendered by Control.tsx, which feeds it the type enums
 * and mirrors it needs from the store. A control panel that renders UnitPanel
 * as the universal fallback has to supply that same set — and silently degrades
 * if it doesn't: without `operationStatusesMirror` the panel cannot resolve its
 * on/off values, so every power toggle collapses to "off" and the unit can be
 * switched off but never back on.
 *
 * Kept as a pure function so the required set is testable on its own, rather
 * than only observable by clicking through the running app.
 */

export interface UnitPanelStoreSlice {
  types?: Record<string, any>;
  operationModesMirror?: any;
  operationStatusesMirror?: any;
  fanModesMirror?: any;
  swingModesMirror?: any;
  temperatureScale?: any;
}

/** Props UnitPanel needs from the store in order to function at all. */
export const REQUIRED_UNIT_PANEL_PROPS = [
  'types',
  'operationModesMirror',
  'operationStatusesMirror',
  'fanModesMirror',
  'swingModesMirror',
  'temperatureScale',
] as const;

export const buildUnitPanelStoreProps = ({
  types,
  operationModesMirror,
  operationStatusesMirror,
  fanModesMirror,
  swingModesMirror,
  temperatureScale,
}: UnitPanelStoreSlice) => ({
  types: {
    operationStatuses: types?.operationStatuses,
    fanModes: types?.fanModes,
    operationModesExtended: types?.operationModesExtended,
    swingModes: types?.swingModes,
    unitSubTypes: types?.unitSubTypes,
    unitTypes: types?.unitTypes,
  },
  operationModesMirror,
  operationStatusesMirror,
  fanModesMirror,
  swingModesMirror,
  temperatureScale,
});
